// @flow
import React from 'react'
import styled from 'styled-components'
import { Link } from 'react-router'
import theme from '../../styles/theme'
import colors from '../../styles/colors'

type Props = {
  to?: string,
  href?: string,
  children?: any,
  style?: Object,
  onClick?: Function,
  disabled?: boolean,
  type?: 'submit' | 'button',
  small?: boolean,
  color?: string,
  animating?: boolean
}

const Component = ({
  to,
  type,
  href,
  style,
  onClick,
  disabled,
  children,
  small, // eslint-disable-line no-unused-vars
  color, // eslint-disable-line no-unused-vars
  animating,
  ...rest
}: Props) => {
  let Tag = 'button'
  if (to) Tag = Link
  if (href) Tag = 'a'
  return (
    <Tag
      to={to}
      href={href}
      type={type}
      style={style}
      onClick={onClick}
      disabled={disabled}
      {...rest}
    >
      {animating && (
        <span
          className="fa fa-spinner fa-pulse"
          style={{ marginRight: '5px' }}
        />
      )}
      {children}
    </Tag>
  )
}

const StyledComponent = styled(Component)`
  display: inline-block;
  padding: ${(props) => (props.small ? '4px 8px' : '5px 10px')};
  font-size: ${(props) => (props.small ? '90%' : 'inherit')};
  cursor: pointer;
  color: ${(props) => (props.color ? '#fff' : 'rgb(55,55,55)')};
  background: ${(props) =>
    props.color ? colors[props.color] : 'rgb(248,248,248)'};
  border: 1px solid transparent;
  border-color: ${(props) =>
    props.color ? 'transparent' : 'rgb(220,220,220)'};
  border-radius: 4px;
  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.05);
  text-align: center;

  &:hover,
  &:focus {
    color: ${(props) => (props.color ? '#fff' : 'rgb(55,55,55)')};
    border-color: ${(props) =>
      props.color ? 'transparent' : 'rgb(200,200,200)'};
    background: ${(props) =>
      props.color ? theme[props.color].lighten(0.1) : 'rgb(240,240,240)'};
    box-shadow: 0 1px 0 rgba(0, 0, 0, 0.1);
    text-decoration: none;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`

const Button = (props: { children?: any }) => (
  <StyledComponent {...props}>{props.children}</StyledComponent>
)

export default Button



// WEBPACK FOOTER //
// ./src/components/Button/index.js